export const WarehouseLogo = (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 8C0 3.58172 3.58172 0 8 0H24C28.4183 0 32 3.58172 32 8V24C32 28.4183 28.4183 32 24 32H8C3.58172 32 0 28.4183 0 24V8Z"
      fill="#296DFF"
    />
    <path
      d="M8.95693 9H5L8.4821 20.0353L10.3814 13.6118L8.95693 9Z"
      fill="#EFF6FF"
    />
    <path
      d="M17.9783 9H14.6545L10.0645 23H13.5465L16.2373 14.4353L17.5035 20.0353L19.4028 13.6118L17.9783 9Z"
      fill="#EFF6FF"
    />
    <path d="M26.9999 9H23.3595L18.9277 23H22.7264L26.9999 9Z" fill="#EFF6FF" />
  </svg>
);

export const SidebarTriggerIcon = ({ className = 'w-4 h-4' }) => (
  <svg
    className={className}
    width="14"
    height="16"
    viewBox="0 0 14 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.5 3.5C11.9148 3.5 12.25 3.83516 12.25 4.25V5.75H1.75V4.25C1.75 3.83516 2.08516 3.5 2.5 3.5H11.5ZM1.75 11.75V6.5H4.75V12.5H2.5C2.08516 12.5 1.75 12.1648 1.75 11.75ZM5.5 12.5V6.5H12.25V11.75C12.25 12.1648 11.9148 12.5 11.5 12.5H5.5ZM2.5 2.75C1.67266 2.75 1 3.42266 1 4.25V11.75C1 12.5773 1.67266 13.25 2.5 13.25H11.5C12.3273 13.25 13 12.5773 13 11.75V4.25C13 3.42266 12.3273 2.75 11.5 2.75H2.5Z"
      fill="currentColor"
    />
  </svg>
);

export const UbicacionesIcon = ({ className = 'w-4 h-4' }) => (
  <svg
    className={className}
    width="15"
    height="13"
    viewBox="0 0 15 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Iconos" clipPath="url(#clip0_875_773)">
      <path
        id="Primary"
        d="M0.375 0.5C0.58125 0.5 0.75 0.66875 0.75 0.875V4.25H14.25V0.875C14.25 0.66875 14.4187 0.5 14.625 0.5C14.8313 0.5 15 0.66875 15 0.875V4.625V10.625V12.125C15 12.3313 14.8313 12.5 14.625 12.5C14.4187 12.5 14.25 12.3313 14.25 12.125V11H0.75V12.125C0.75 12.3313 0.58125 12.5 0.375 12.5C0.16875 12.5 0 12.3313 0 12.125V10.625V4.625V0.875C0 0.66875 0.16875 0.5 0.375 0.5ZM0.75 10.25H14.25V5H0.75V10.25ZM10.5 1.25H9V2.75H10.5V1.25ZM9 0.5H10.5C10.9148 0.5 11.25 0.835156 11.25 1.25V2.75C11.25 3.16484 10.9148 3.5 10.5 3.5H9C8.58516 3.5 8.25 3.16484 8.25 2.75V1.25C8.25 0.835156 8.58516 0.5 9 0.5ZM3 7.25V8.75H4.5V7.25H3ZM2.25 7.25C2.25 6.83516 2.58516 6.5 3 6.5H4.5C4.91484 6.5 5.25 6.83516 5.25 7.25V8.75C5.25 9.16484 4.91484 9.5 4.5 9.5H3C2.58516 9.5 2.25 9.16484 2.25 8.75V7.25ZM6.75 7.25V8.75H8.25V7.25H6.75ZM6 7.25C6 6.83516 6.33516 6.5 6.75 6.5H8.25C8.66484 6.5 9 6.83516 9 7.25V8.75C9 9.16484 8.66484 9.5 8.25 9.5H6.75C6.33516 9.5 6 9.16484 6 8.75V7.25Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_875_773">
        <rect
          width="15"
          height="12"
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const TiendasIcon = ({ className = 'w-4 h-4' }) => (
  <svg
    className={className}
    width="14"
    height="13"
    viewBox="0 0 14 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Iconos" clipPath="url(#clip0_875_743)">
      <path
        id="Primary"
        d="M12.2022 3.33359C12.6405 4.02734 12.2093 4.89453 11.5179 4.98828C11.4569 4.99531 11.396 5 11.3327 5C10.946 5 10.6015 4.83125 10.3601 4.56641C10.2171 4.40937 10.0155 4.32031 9.80459 4.32031C9.59365 4.32031 9.39209 4.40937 9.24912 4.56641C9.01006 4.82891 8.66787 4.99766 8.27881 4.99766C7.89209 4.99766 7.54521 4.82891 7.30849 4.56641C7.16552 4.40937 6.96396 4.32031 6.75303 4.32031C6.54209 4.32031 6.33818 4.40937 6.19756 4.56641C5.95381 4.83125 5.60927 5 5.22021 5C4.83349 5 4.48662 4.83125 4.2499 4.56875C4.10693 4.41172 3.90537 4.32266 3.69443 4.32266C3.48349 4.32266 3.27959 4.41172 3.13896 4.56875C2.89756 4.83125 2.55537 5 2.16631 5C2.10537 5 2.04443 4.99531 1.98115 4.98828C1.29443 4.89453 0.863181 4.02734 1.29912 3.33359L2.61631 1.25H10.8851L12.2022 3.33359ZM11.3304 5.75C11.4265 5.75 11.5202 5.74297 11.614 5.73125C12.9147 5.55781 13.5311 4.03203 12.8351 2.93281L11.4921 0.807031C11.3726 0.617188 11.1593 0.5 10.9319 0.5H2.56943C2.34209 0.5 2.12881 0.617188 2.00927 0.807031L0.663962 2.93281C-0.0297882 4.02969 0.584274 5.55547 1.88037 5.73125C1.97412 5.74297 2.07021 5.75 2.16396 5.75C2.62334 5.75 3.04287 5.6 3.38271 5.35156C3.49521 5.26953 3.59834 5.17344 3.69209 5.07266C3.78584 5.17578 3.88896 5.26953 4.00146 5.35156C4.34131 5.6 4.76084 5.75 5.22021 5.75C5.67959 5.75 6.09912 5.6 6.43896 5.35156C6.55146 5.26953 6.65459 5.17344 6.74834 5.07031C6.84209 5.17344 6.94521 5.26719 7.05771 5.34922C7.39756 5.59766 7.81709 5.74766 8.27646 5.74766C8.74053 5.74766 9.1624 5.59531 9.50224 5.34219C9.6124 5.26016 9.71318 5.16875 9.80459 5.06797C9.89599 5.16875 9.99912 5.2625 10.1093 5.34453C10.4491 5.59531 10.871 5.74766 11.3327 5.74766L11.3304 5.75ZM1.87568 6.5C1.66943 6.5 1.50068 6.66875 1.50068 6.875V8.75V9.125V9.5V11C1.50068 11.8273 2.17334 12.5 3.00068 12.5H10.5007C11.328 12.5 12.0007 11.8273 12.0007 11V9.5V9.125V8.75V6.875C12.0007 6.66875 11.8319 6.5 11.6257 6.5C11.4194 6.5 11.2507 6.66875 11.2507 6.875V8.75H2.25068V6.875C2.25068 6.66875 2.08193 6.5 1.87568 6.5ZM2.25068 9.5H11.2507V11C11.2507 11.4148 10.9155 11.75 10.5007 11.75H3.00068C2.58584 11.75 2.25068 11.4148 2.25068 11V9.5Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_875_743">
        <rect
          width="13.5"
          height="12"
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const SuscripcionIcon = ({ className = 'w-4 h-4' }) => (
  <svg
    className={className}
    width="14"
    height="12"
    viewBox="0 0 14 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      id="Primary"
      d="M1.75 1.5C1.33516 1.5 1 1.83516 1 2.25V3H13V2.25C13 1.83516 12.6648 1.5 12.25 1.5H1.75ZM1 3.75V5.25H13V3.75H1ZM1 6V9.75C1 10.1648 1.33516 10.5 1.75 10.5H12.25C12.6648 10.5 13 10.1648 13 9.75V6H1ZM0.25 2.25C0.25 1.42266 0.922656 0.75 1.75 0.75H12.25C13.0773 0.75 13.75 1.42266 13.75 2.25V9.75C13.75 10.5773 13.0773 11.25 12.25 11.25H1.75C0.922656 11.25 0.25 10.5773 0.25 9.75V2.25ZM2.5 8.625C2.5 8.41875 2.66875 8.25 2.875 8.25H4.375C4.58125 8.25 4.75 8.41875 4.75 8.625C4.75 8.83125 4.58125 9 4.375 9H2.875C2.66875 9 2.5 8.83125 2.5 8.625ZM5.5 8.625C5.5 8.41875 5.66875 8.25 5.875 8.25H8.875C9.08125 8.25 9.25 8.41875 9.25 8.625C9.25 8.83125 9.08125 9 8.875 9H5.875C5.66875 9 5.5 8.83125 5.5 8.625Z"
      fill="currentColor"
    />
  </svg>
);

export const ProductosIcon = ({ className = 'w-4 h-4' }) => (
  <svg
    className={className}
    width="11"
    height="13"
    viewBox="0 0 11 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Iconos" clipPath="url(#clip0_875_747)">
      <path
        id="Primary"
        d="M3.75 2.75V3.5H6.75V2.75C6.75 1.92266 6.07734 1.25 5.25 1.25C4.42266 1.25 3.75 1.92266 3.75 2.75ZM3 4.25H1.125C0.91875 4.25 0.75 4.41875 0.75 4.625V10.25C0.75 11.0773 1.42266 11.75 2.25 11.75H8.25C9.07734 11.75 9.75 11.0773 9.75 10.25V4.625C9.75 4.41875 9.58125 4.25 9.375 4.25H7.5V6.125C7.5 6.33125 7.33125 6.5 7.125 6.5C6.91875 6.5 6.75 6.33125 6.75 6.125V4.25H3.75V6.125C3.75 6.33125 3.58125 6.5 3.375 6.5C3.16875 6.5 3 6.33125 3 6.125V4.25ZM3 3.5V2.75C3 1.50781 4.00781 0.5 5.25 0.5C6.49219 0.5 7.5 1.50781 7.5 2.75V3.5H9.375C9.99609 3.5 10.5 4.00391 10.5 4.625V10.25C10.5 11.4922 9.49219 12.5 8.25 12.5H2.25C1.00781 12.5 0 11.4922 0 10.25V4.625C0 4.00391 0.503906 3.5 1.125 3.5H3Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_875_747">
        <rect
          width="10.5"
          height="12"
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const PreparacionIcon = ({ className = 'w-4 h-4' }) => (
  <svg
    className={className}
    width="15"
    height="13"
    viewBox="0 0 15 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Iconos">
      <path
        id="Primary"
        d="M1.88347 1.66051L7.49909 2.30973L13.1147 1.66051C13.4452 1.62301 13.7592 1.80583 13.8905 2.11051L14.6405 3.86129C14.8702 4.39801 14.5585 5.01208 13.9889 5.14333L10.2577 6.00348C9.81472 6.10661 9.353 5.93083 9.08815 5.56051L7.49909 3.33395L5.90768 5.56286C5.64284 5.93317 5.18347 6.10661 4.73815 6.00583L1.0069 5.14098C0.437372 5.00973 0.125653 4.39567 0.35534 3.85895L1.10534 2.10817C1.23659 1.80348 1.55065 1.62067 1.88112 1.65817L1.88347 1.66051ZM1.79675 2.40583L1.04675 4.15661C0.999872 4.26442 1.06315 4.3863 1.178 4.41208L4.90925 5.27223C5.0569 5.30739 5.21159 5.2488 5.29831 5.12458L6.82409 2.98708L1.79675 2.40583ZM12.7491 6.04801L13.4991 5.83473V9.3738C13.4991 9.88942 13.1475 10.3394 12.646 10.466L7.77097 11.6847C7.59284 11.7293 7.40534 11.7293 7.22487 11.6847L2.34987 10.466C1.85065 10.3371 1.49909 9.88942 1.49909 9.37145V5.83239L2.24909 6.04567V9.36911C2.24909 9.5402 2.36628 9.6902 2.53268 9.73239L7.12409 10.8832V5.37536C7.12409 5.16911 7.29284 5.00036 7.49909 5.00036C7.70534 5.00036 7.87409 5.16911 7.87409 5.37536V10.8832L12.4655 9.73473C12.6319 9.69255 12.7491 9.54255 12.7491 9.37145V6.04801ZM8.17409 2.98708L9.69987 5.12458C9.78893 5.2488 9.94128 5.30505 10.0889 5.27223L13.8202 4.41208C13.935 4.3863 13.996 4.26208 13.9514 4.15661L13.2014 2.40583L8.17409 2.98708Z"
        fill="currentColor"
      />
    </g>
  </svg>
);

export const PerfilIcon = ({ className = 'w-4 h-4' }) => (
  <svg
    className={className}
    width="11"
    height="12"
    viewBox="0 0 11 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="user" clipPath="url(#clip0_875_643)">
      <path
        id="Primary"
        d="M7.5 3C7.5 2.70453 7.4418 2.41194 7.32873 2.13896C7.21566 1.86598 7.04992 1.61794 6.84099 1.40901C6.63206 1.20008 6.38402 1.03434 6.11104 0.921271C5.83806 0.808198 5.54547 0.75 5.25 0.75C4.95453 0.75 4.66194 0.808198 4.38896 0.921271C4.11598 1.03434 3.86794 1.20008 3.65901 1.40901C3.45008 1.61794 3.28434 1.86598 3.17127 2.13896C3.0582 2.41194 3 2.70453 3 3C3 3.29547 3.0582 3.58806 3.17127 3.86104C3.28434 4.13402 3.45008 4.38206 3.65901 4.59099C3.86794 4.79992 4.11598 4.96566 4.38896 5.07873C4.66194 5.1918 4.95453 5.25 5.25 5.25C5.54547 5.25 5.83806 5.1918 6.11104 5.07873C6.38402 4.96566 6.63206 4.79992 6.84099 4.59099C7.04992 4.38206 7.21566 4.13402 7.32873 3.86104C7.4418 3.58806 7.5 3.29547 7.5 3ZM2.25 3C2.25 2.20435 2.56607 1.44129 3.12868 0.87868C3.69129 0.316071 4.45435 0 5.25 0C6.04565 0 6.80871 0.316071 7.37132 0.87868C7.93393 1.44129 8.25 2.20435 8.25 3C8.25 3.79565 7.93393 4.55871 7.37132 5.12132C6.80871 5.68393 6.04565 6 5.25 6C4.45435 6 3.69129 5.68393 3.12868 5.12132C2.56607 4.55871 2.25 3.79565 2.25 3ZM0.75 11.25H9.75C9.72188 9.38203 8.19844 7.875 6.32109 7.875H4.17891C2.30391 7.875 0.780469 9.38203 0.75 11.25ZM0 11.3039C0 8.99531 1.87031 7.125 4.17891 7.125H6.32109C8.62969 7.125 10.5 8.99531 10.5 11.3039C10.5 11.6883 10.1883 12 9.80391 12H0.696094C0.311719 12 0 11.6883 0 11.3039Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_875_643">
        <rect width="10.5" height="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const PedidosIcon = ({ className = 'w-4 h-4' }) => (
  <svg
    className={className}
    width="14"
    height="13"
    viewBox="0 0 14 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Iconos" clipPath="url(#clip0_875_751)">
      <path
        id="Primary"
        d="M0.375 0.5C0.16875 0.5 0 0.66875 0 0.875C0 1.08125 0.16875 1.25 0.375 1.25H1.26328C1.44141 1.25 1.59609 1.37422 1.63125 1.55L3.01172 8.3C3.15469 8.99844 3.76875 9.5 4.48125 9.5H11.625C11.8313 9.5 12 9.33125 12 9.125C12 8.91875 11.8313 8.75 11.625 8.75H4.48125C4.125 8.75 3.81797 8.49922 3.74531 8.15L3.5625 7.25H10.9359C11.625 7.25 12.225 6.78125 12.3914 6.11328L13.3734 2.18281C13.4906 1.70938 13.1344 1.25 12.6469 1.25H2.32266C2.16797 0.804688 1.74375 0.5 1.26328 0.5H0.375ZM2.48672 2H12.6445L11.6625 5.93281C11.5781 6.26562 11.2781 6.5 10.9336 6.5H3.40781L2.48672 2ZM3.9375 11.1875C3.9375 11.0383 3.99676 10.8952 4.10225 10.7898C4.20774 10.6843 4.35082 10.625 4.5 10.625C4.64918 10.625 4.79226 10.6843 4.89775 10.7898C5.00324 10.8952 5.0625 11.0383 5.0625 11.1875C5.0625 11.3367 5.00324 11.4798 4.89775 11.5852C4.79226 11.6907 4.64918 11.75 4.5 11.75C4.35082 11.75 4.20774 11.6907 4.10225 11.5852C3.99676 11.4798 3.9375 11.3367 3.9375 11.1875ZM5.8125 11.1875C5.8125 11.0151 5.77855 10.8445 5.71259 10.6852C5.64663 10.526 5.54995 10.3813 5.42808 10.2594C5.3062 10.1375 5.16151 10.0409 5.00227 9.97491C4.84303 9.90895 4.67236 9.875 4.5 9.875C4.32764 9.875 4.15697 9.90895 3.99773 9.97491C3.83849 10.0409 3.6938 10.1375 3.57192 10.2594C3.45005 10.3813 3.35337 10.526 3.28741 10.6852C3.22145 10.8445 3.1875 11.0151 3.1875 11.1875C3.1875 11.3599 3.22145 11.5305 3.28741 11.6898C3.35337 11.849 3.45005 11.9937 3.57192 12.1156C3.6938 12.2375 3.83849 12.3341 3.99773 12.4001C4.15697 12.4661 4.32764 12.5 4.5 12.5C4.67236 12.5 4.84303 12.4661 5.00227 12.4001C5.16151 12.3341 5.3062 12.2375 5.42808 12.1156C5.54995 11.9937 5.64663 11.849 5.71259 11.6898C5.77855 11.5305 5.8125 11.3599 5.8125 11.1875ZM10.5 10.625C10.6492 10.625 10.7923 10.6843 10.8977 10.7898C11.0032 10.8952 11.0625 11.0383 11.0625 11.1875C11.0625 11.3367 11.0032 11.4798 10.8977 11.5852C10.7923 11.6907 10.6492 11.75 10.5 11.75C10.3508 11.75 10.2077 11.6907 10.1023 11.5852C9.99676 11.4798 9.9375 11.3367 9.9375 11.1875C9.9375 11.0383 9.99676 10.8952 10.1023 10.7898C10.2077 10.6843 10.3508 10.625 10.5 10.625ZM10.5 12.5C10.8481 12.5 11.1819 12.3617 11.4281 12.1156C11.6742 11.8694 11.8125 11.5356 11.8125 11.1875C11.8125 10.8394 11.6742 10.5056 11.4281 10.2594C11.1819 10.0133 10.8481 9.875 10.5 9.875C10.1519 9.875 9.81806 10.0133 9.57192 10.2594C9.32578 10.5056 9.1875 10.8394 9.1875 11.1875C9.1875 11.5356 9.32578 11.8694 9.57192 12.1156C9.81806 12.3617 10.1519 12.5 10.5 12.5Z"
        fill="#EFF6FF"
      />
    </g>
    <defs>
      <clipPath id="clip0_875_751">
        <rect
          width="13.5"
          height="12"
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const PacksIcon = ({ className = 'w-4 h-4' }) => (
  <svg
    className={className}
    width="14"
    height="13"
    viewBox="0 0 14 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Iconos" clipPath="url(#clip0_875_759)">
      <path
        id="Primary"
        d="M9 1.25C9.41484 1.25 9.75 1.58516 9.75 2V5H10.5V2C10.5 1.17266 9.82734 0.5 9 0.5H7.5H6H4.5C3.67266 0.5 3 1.17266 3 2V5H3.75V2C3.75 1.58516 4.08516 1.25 4.5 1.25H5.25V2.5625C5.25 3.08047 5.66953 3.5 6.1875 3.5H7.3125C7.83047 3.5 8.25 3.08047 8.25 2.5625V1.25H9ZM6 1.25H7.5V2.5625C7.5 2.66563 7.41563 2.75 7.3125 2.75H6.1875C6.08437 2.75 6 2.66563 6 2.5625V1.25ZM7.67813 12.5H12C12.8273 12.5 13.5 11.8273 13.5 11V7.25C13.5 6.42266 12.8273 5.75 12 5.75H10.5H9H7.67813C7.87266 5.96562 8.025 6.22109 8.12344 6.5H8.25234V7.24766C8.25234 7.24766 8.25234 7.24766 8.25234 7.25V7.8125C8.25234 8.33047 8.67188 8.75 9.18984 8.75H10.3148C10.8328 8.75 11.2523 8.33047 11.2523 7.8125V6.5H12.0023C12.4172 6.5 12.7523 6.83516 12.7523 7.25V11C12.7523 11.4148 12.4172 11.75 12.0023 11.75H8.12344C8.025 12.0289 7.87266 12.2844 7.67813 12.5ZM9 6.5H10.5V7.8125C10.5 7.91563 10.4156 8 10.3125 8H9.1875C9.08438 8 9 7.91563 9 7.8125V6.5ZM6 6.5C6.41484 6.5 6.75 6.83516 6.75 7.25V11C6.75 11.4148 6.41484 11.75 6 11.75H1.5C1.08516 11.75 0.75 11.4148 0.75 11V7.25C0.75 6.83516 1.08516 6.5 1.5 6.5H2.25V7.8125C2.25 8.33047 2.66953 8.75 3.1875 8.75H4.3125C4.83047 8.75 5.25 8.33047 5.25 7.8125V6.5H6ZM3 7.8125V6.5H4.5V7.8125C4.5 7.91563 4.41563 8 4.3125 8H3.1875C3.08437 8 3 7.91563 3 7.8125ZM6 5.75H5.25H4.5H3H2.25H1.5C0.672656 5.75 0 6.42266 0 7.25V11C0 11.8273 0.672656 12.5 1.5 12.5H6C6.82734 12.5 7.5 11.8273 7.5 11V7.25C7.5 6.42266 6.82734 5.75 6 5.75Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_875_759">
        <rect
          width="13.5"
          height="12"
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const OrdenesUbicacionIcon = ({ className = 'w-4 h-4' }) => (
  <svg
    className={className}
    width="12"
    height="10"
    viewBox="0 0 12 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.1 0.625H5.7C5.535 0.625 5.4 0.765625 5.4 0.9375V2.5H4.8V0.9375C4.8 0.419922 5.20312 0 5.7 0H11.1C11.5969 0 12 0.419922 12 0.9375V9.0625C12 9.58008 11.5969 10 11.1 10H7.14937C7.18313 9.90234 7.2 9.79688 7.2 9.6875V9.375H11.1C11.265 9.375 11.4 9.23438 11.4 9.0625V0.9375C11.4 0.765625 11.265 0.625 11.1 0.625ZM10.4119 6.18555C10.5281 6.30664 10.5281 6.50586 10.4119 6.62695C10.2956 6.74805 10.1044 6.74805 9.98813 6.62695L9.3 5.91016V8.4375C9.3 8.60938 9.165 8.75 9 8.75C8.835 8.75 8.7 8.60938 8.7 8.4375V5.91016L8.01188 6.62695C7.89563 6.74805 7.70438 6.74805 7.58813 6.62695C7.47188 6.50586 7.47188 6.30664 7.58813 6.18555L8.78813 4.93555C8.90438 4.81445 9.09562 4.81445 9.21187 4.93555L10.4119 6.18555ZM6.6 3.75H0.6V5H1.2H6H6.6V3.75ZM0 5V3.75C0 3.4043 0.268125 3.125 0.6 3.125H6.6C6.93188 3.125 7.2 3.4043 7.2 3.75V5C7.2 5.3457 6.93188 5.625 6.6 5.625V9.375C6.6 9.7207 6.33188 10 6 10H1.2C0.868125 10 0.6 9.7207 0.6 9.375V5.625C0.268125 5.625 0 5.3457 0 5ZM1.2 5.625V9.375H6V5.625H1.2ZM2.7 6.25H4.5C4.665 6.25 4.8 6.39062 4.8 6.5625C4.8 6.73438 4.665 6.875 4.5 6.875H2.7C2.535 6.875 2.4 6.73438 2.4 6.5625C2.4 6.39062 2.535 6.25 2.7 6.25Z"
      fill="currentColor"
    />
  </svg>
);

export const MovimientosIcon = ({ className = 'w-4 h-4' }) => (
  <svg
    className={className}
    width="14"
    height="13"
    viewBox="0 0 14 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="pallet-box" clipPath="url(#clip0_875_778)">
      <path
        id="Primary"
        d="M10.375 1.25C10.5813 1.25 10.75 1.41875 10.75 1.625V6.125C10.75 6.33125 10.5813 6.5 10.375 6.5H3.625C3.41875 6.5 3.25 6.33125 3.25 6.125V1.625C3.25 1.41875 3.41875 1.25 3.625 1.25H5.125V3.875C5.125 4.01797 5.20469 4.14688 5.33125 4.21016C5.45781 4.27344 5.61016 4.25938 5.725 4.175L7 3.21875L8.275 4.175C8.3875 4.25938 8.53984 4.27344 8.66875 4.21016C8.79766 4.14688 8.875 4.01562 8.875 3.875V1.25H10.375ZM5.875 1.25H8.125V3.125L7.225 2.45C7.09141 2.34922 6.90859 2.34922 6.775 2.45L5.875 3.125V1.25ZM3.625 0.5C3.00391 0.5 2.5 1.00391 2.5 1.625V6.125C2.5 6.74609 3.00391 7.25 3.625 7.25H10.375C10.9961 7.25 11.5 6.74609 11.5 6.125V1.625C11.5 1.00391 10.9961 0.5 10.375 0.5H3.625ZM-0.5 9.125C-0.5 9.33125 -0.33125 9.5 -0.125 9.5H1V11.75H-0.125C-0.33125 11.75 -0.5 11.9187 -0.5 12.125C-0.5 12.3313 -0.33125 12.5 -0.125 12.5H1.375H7H12.625H14.125C14.3313 12.5 14.5 12.3313 14.5 12.125C14.5 11.9187 14.3313 11.75 14.125 11.75H13V9.5H14.125C14.3313 9.5 14.5 9.33125 14.5 9.125C14.5 8.91875 14.3313 8.75 14.125 8.75H12.625H7H1.375H-0.125C-0.33125 8.75 -0.5 8.91875 -0.5 9.125ZM1.75 11.75V9.5H6.625V11.75H1.75ZM7.375 11.75V9.5H12.25V11.75H7.375Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_875_778">
        <rect
          width="15"
          height="12"
          fill="white"
          transform="translate(-0.5 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const MercanciasIcon = ({ className = 'w-4 h-4' }) => (
  <svg
    className={className}
    width="14"
    height="12"
    viewBox="0 0 14 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="dolly" clipPath="url(#clip0_875_765)">
      <path
        id="Primary"
        d="M0.5625 0C0.35625 0 0.1875 0.16875 0.1875 0.375C0.1875 0.58125 0.35625 0.75 0.5625 0.75H2.08359C2.24531 0.75 2.38828 0.853125 2.43984 1.00547L4.95938 8.56406C4.45547 8.90156 4.125 9.47344 4.125 10.125C4.125 11.1609 4.96406 12 6 12C7.00781 12 7.82812 11.2055 7.87266 10.2094L13.2539 8.22656C13.4484 8.15391 13.5469 7.93828 13.4766 7.74609C13.4062 7.55391 13.1883 7.45312 12.9961 7.52344L7.75078 9.45469C7.48125 8.74922 6.79922 8.25 6 8.25C5.88281 8.25 5.76797 8.26172 5.65547 8.28047L3.15234 0.76875C2.99766 0.309375 2.56875 0 2.08359 0H0.5625ZM6 9C6.29837 9 6.58452 9.11853 6.7955 9.3295C7.00647 9.54048 7.125 9.82663 7.125 10.125C7.125 10.4234 7.00647 10.7095 6.7955 10.9205C6.58452 11.1315 6.29837 11.25 6 11.25C5.70163 11.25 5.41548 11.1315 5.2045 10.9205C4.99353 10.7095 4.875 10.4234 4.875 10.125C4.875 9.82663 4.99353 9.54048 5.2045 9.3295C5.41548 9.11853 5.70163 9 6 9ZM8.26875 4.28672C8.33906 4.48125 8.55469 4.58203 8.74922 4.51172C8.94375 4.44141 9.04453 4.22578 8.97422 4.03125L8.52422 2.79844L9.93281 2.28516L11.2148 5.81016L7.69219 7.08984L6.41016 3.56719L7.81875 3.05391L8.26875 4.28672ZM5.70469 3.82266L6.98672 7.34766C7.12734 7.73672 7.55859 7.93828 7.94766 7.79531L11.4727 6.51328C11.8617 6.37266 12.0633 5.94141 11.9203 5.55234L10.6383 2.02734C10.4977 1.63828 10.0664 1.43672 9.67734 1.57969L6.15234 2.86172C5.76328 3.00234 5.56172 3.43359 5.70469 3.82266Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_875_765">
        <rect width="13.5" height="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const ImpresoraIcon = ({ className = 'w-4 h-4' }) => (
  <svg
    className={className}
    width="12"
    height="13"
    viewBox="0 0 12 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      id="Primary"
      d="M2.25 4.25H1.5V2C1.5 1.17266 2.17266 0.5 3 0.5H8.37891C8.77734 0.5 9.15937 0.657031 9.44062 0.938281L10.0617 1.55938C10.343 1.84063 10.5 2.22266 10.5 2.62109V4.25H9.75V2.62109C9.75 2.42188 9.67031 2.23203 9.52969 2.09141L8.90859 1.47031C8.76797 1.32969 8.57812 1.25 8.37891 1.25H3C2.58516 1.25 2.25 1.58516 2.25 2V4.25ZM10.5 5.75H1.5C1.08516 5.75 0.75 6.08516 0.75 6.5V9.5H1.5V8.75C1.5 8.33516 1.83516 8 2.25 8H9.75C10.1648 8 10.5 8.33516 10.5 8.75V9.5H11.25V6.5C11.25 6.08516 10.9148 5.75 10.5 5.75ZM10.5 10.25V11.75C10.5 12.1648 10.1648 12.5 9.75 12.5H2.25C1.83516 12.5 1.5 12.1648 1.5 11.75V10.25H0.75C0.335156 10.25 0 9.91484 0 9.5V6.5C0 5.67266 0.672656 5 1.5 5H10.5C11.3273 5 12 5.67266 12 6.5V9.5C12 9.91484 11.6648 10.25 11.25 10.25H10.5ZM2.25 8.75V11.75H9.75V8.75H2.25ZM10.125 6.3125C10.2742 6.3125 10.4173 6.37176 10.5227 6.47725C10.6282 6.58274 10.6875 6.72582 10.6875 6.875C10.6875 7.02418 10.6282 7.16726 10.5227 7.27275C10.4173 7.37824 10.2742 7.4375 10.125 7.4375C9.97582 7.4375 9.83274 7.37824 9.72725 7.27275C9.62176 7.16726 9.5625 7.02418 9.5625 6.875C9.5625 6.72582 9.62176 6.58274 9.72725 6.47725C9.83274 6.37176 9.97582 6.3125 10.125 6.3125Z"
      fill="currentColor"
    />
  </svg>
);

export const CerrarIcon = ({ className = 'w-4 h-4' }) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Iconos">
      <path
        id="Primary"
        d="M13.8898 8.26484C14.0352 8.11953 14.0352 7.88047 13.8898 7.73516L10.8898 4.73516C10.7445 4.58984 10.5055 4.58984 10.3602 4.73516C10.2148 4.88047 10.2148 5.11953 10.3602 5.26484L12.7203 7.625H6.125C5.91875 7.625 5.75 7.79375 5.75 8C5.75 8.20625 5.91875 8.375 6.125 8.375H12.7203L10.3602 10.7352C10.2148 10.8805 10.2148 11.1195 10.3602 11.2648C10.5055 11.4102 10.7445 11.4102 10.8898 11.2648L13.8898 8.26484ZM6.125 3.5C6.33125 3.5 6.5 3.33125 6.5 3.125C6.5 2.91875 6.33125 2.75 6.125 2.75H3.875C2.83906 2.75 2 3.58906 2 4.625V11.375C2 12.4109 2.83906 13.25 3.875 13.25H6.125C6.33125 13.25 6.5 13.0813 6.5 12.875C6.5 12.6687 6.33125 12.5 6.125 12.5H3.875C3.25391 12.5 2.75 11.9961 2.75 11.375V4.625C2.75 4.00391 3.25391 3.5 3.875 3.5H6.125Z"
        fill="currentColor"
      />
    </g>
  </svg>
);

export const EmpresaIcon = ({ className = 'w-4 h-4' }) => (
  <svg
    className={className}
    width="9"
    height="12"
    viewBox="0 0 9 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      id="Primary"
      d="M1.5 0.75C1.08516 0.75 0.75 1.08516 0.75 1.5V10.5C0.75 10.9148 1.08516 11.25 1.5 11.25H3V9.375C3 8.75391 3.50391 8.25 4.125 8.25H4.875C5.49609 8.25 6 8.75391 6 9.375V11.25H7.5C7.91484 11.25 8.25 10.9148 8.25 10.5V1.5C8.25 1.08516 7.91484 0.75 7.5 0.75H1.5ZM3.75 11.25H5.25V9.375C5.25 9.16875 5.08125 9 4.875 9H4.125C3.91875 9 3.75 9.16875 3.75 9.375V11.25ZM3 12H1.5C0.672656 12 0 11.3273 0 10.5V1.5C0 0.672656 0.672656 0 1.5 0H7.5C8.32734 0 9 0.672656 9 1.5V10.5C9 11.3273 8.32734 12 7.5 12H3ZM5.25 3C5.25 2.79375 5.41875 2.625 5.625 2.625H6C6.20625 2.625 6.375 2.79375 6.375 3V3.375C6.375 3.58125 6.20625 3.75 6 3.75H5.625C5.41875 3.75 5.25 3.58125 5.25 3.375V3ZM5.625 5.25H6C6.20625 5.25 6.375 5.41875 6.375 5.625V6C6.375 6.20625 6.20625 6.375 6 6.375H5.625C5.41875 6.375 5.25 6.20625 5.25 6V5.625C5.25 5.41875 5.41875 5.25 5.625 5.25ZM2.625 3C2.625 2.79375 2.79375 2.625 3 2.625H3.375C3.58125 2.625 3.75 2.79375 3.75 3V3.375C3.75 3.58125 3.58125 3.75 3.375 3.75H3C2.79375 3.75 2.625 3.58125 2.625 3.375V3ZM3 5.25H3.375C3.58125 5.25 3.75 5.41875 3.75 5.625V6C3.75 6.20625 3.58125 6.375 3.375 6.375H3C2.79375 6.375 2.625 6.20625 2.625 6V5.625C2.625 5.41875 2.79375 5.25 3 5.25Z"
      fill="currentColor"
    />
  </svg>
);

export const RehusableIcon = ({ className = 'w-4 h-4' }) => (
  <svg
    className={className}
    width="20"
    height="20"
    viewBox="0 0 29 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.18965 10.7759L14.2672 16.1293M5.18965 10.7759L7.5 9M5.18965 10.7759L1.23228 13.8538C1.12083 13.9405 1.13186 14.1122 1.25347 14.184L4.5521 16.1293M14.2672 16.1293L23.5776 10.7759M14.2672 16.1293L18.3543 19.0811C18.417 19.1263 18.5001 19.1314 18.5678 19.0942L27.5009 14.181C27.6269 14.1117 27.6408 13.9361 27.5273 13.8479L23.5776 10.7759M14.2672 16.1293L10.1849 19.3045C10.1201 19.3548 10.0312 19.3606 9.9605 19.3189L4.5521 16.1293M14.2672 16.1293V28M23.5776 10.7759L20.5 9M4.5521 16.1293V22.7586C4.5521 22.8329 4.59319 22.901 4.65884 22.9356L14.2672 28M14.2672 28L23.9392 22.7035C24.0033 22.6684 24.0431 22.6011 24.0431 22.528V16.5948"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M9.73329 2.41791C9.73744 2.75031 9.73965 3.15685 9.73965 3.65025V4.40025H10.4897H10.8096C10.8092 4.40025 10.8096 4.40027 10.8108 4.40034C10.8177 4.40075 10.8524 4.40277 10.9245 4.41139C11.0002 4.42044 11.0967 4.43421 11.2081 4.45222C11.4308 4.48824 11.6978 4.53875 11.9516 4.59534L11.9515 4.59541L11.962 4.59759C12.4624 4.70174 13.1811 4.96666 13.629 5.21003C14.0543 5.45604 14.6924 5.95176 15.0247 6.29606C15.355 6.65299 15.7833 7.25925 15.9517 7.58784C16.0332 7.74694 16.1338 7.97559 16.2314 8.22165C16.1815 8.16909 16.133 8.11937 16.0871 8.0735L16.0815 8.06787L16.0757 8.06235C15.7183 7.72016 15.124 7.27324 14.6954 7.05728C14.311 6.858 13.6521 6.60224 13.1897 6.47101L13.1791 6.468L13.1684 6.4653C12.7051 6.34842 11.9419 6.19713 10.5782 6.03494L9.73965 5.93521V6.77969V8.12181C9.27635 7.73374 8.70576 7.26385 8.09836 6.78837C7.37719 6.22385 6.72134 5.70365 6.24696 5.3206C6.21496 5.29476 6.18386 5.2696 6.15366 5.24513C6.1852 5.21932 6.21775 5.19273 6.25127 5.16541C6.72678 4.77778 7.3853 4.25137 8.11198 3.68087C8.71531 3.20722 9.27803 2.7687 9.73329 2.41791Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </svg>
);

export const FilterIcon = ({ className = 'w-4 h-4' }) => (
  <svg
    className={className}
    width="11"
    height="11"
    viewBox="0 0 11 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 9.375C0 9.58125 0.16875 9.75 0.375 9.75H1.9125C2.08594 10.6055 2.84297 11.25 3.75 11.25C4.65703 11.25 5.41406 10.6055 5.5875 9.75H11.625C11.8313 9.75 12 9.58125 12 9.375C12 9.16875 11.8313 9 11.625 9H5.5875C5.41406 8.14453 4.65703 7.5 3.75 7.5C2.84297 7.5 2.08594 8.14453 1.9125 9H0.375C0.16875 9 0 9.16875 0 9.375ZM2.625 9.375C2.625 9.07663 2.74353 8.79048 2.9545 8.5795C3.16548 8.36853 3.45163 8.25 3.75 8.25C4.04837 8.25 4.33452 8.36853 4.5455 8.5795C4.75647 8.79048 4.875 9.07663 4.875 9.375C4.875 9.67337 4.75647 9.95952 4.5455 10.1705C4.33452 10.3815 4.04837 10.5 3.75 10.5C3.45163 10.5 3.16548 10.3815 2.9545 10.1705C2.74353 9.95952 2.625 9.67337 2.625 9.375ZM7.125 5.625C7.125 5.47726 7.1541 5.33097 7.21064 5.19448C7.26717 5.05799 7.35004 4.93397 7.4545 4.8295C7.55897 4.72504 7.68299 4.64217 7.81948 4.58564C7.95597 4.5291 8.10226 4.5 8.25 4.5C8.39774 4.5 8.54403 4.5291 8.68052 4.58564C8.81701 4.64217 8.94103 4.72504 9.0455 4.8295C9.14996 4.93397 9.23283 5.05799 9.28936 5.19448C9.3459 5.33097 9.375 5.47726 9.375 5.625C9.375 5.77274 9.3459 5.91903 9.28936 6.05552C9.23283 6.19201 9.14996 6.31603 9.0455 6.4205C8.94103 6.52496 8.81701 6.60783 8.68052 6.66436C8.54403 6.7209 8.39774 6.75 8.25 6.75C8.10226 6.75 7.95597 6.7209 7.81948 6.66436C7.68299 6.60783 7.55897 6.52496 7.4545 6.4205C7.35004 6.31603 7.26717 6.19201 7.21064 6.05552C7.1541 5.91903 7.125 5.77274 7.125 5.625ZM8.25 3.75C7.34297 3.75 6.58594 4.39453 6.4125 5.25H0.375C0.16875 5.25 0 5.41875 0 5.625C0 5.83125 0.16875 6 0.375 6H6.4125C6.58594 6.85547 7.34297 7.5 8.25 7.5C9.15703 7.5 9.91406 6.85547 10.0875 6H11.625C11.8313 6 12 5.83125 12 5.625C12 5.41875 11.8313 5.25 11.625 5.25H10.0875C9.91406 4.39453 9.15703 3.75 8.25 3.75ZM4.5 3C4.20163 3 3.91548 2.88147 3.7045 2.6705C3.49353 2.45952 3.375 2.17337 3.375 1.875C3.375 1.57663 3.49353 1.29048 3.7045 1.0795C3.91548 0.868526 4.20163 0.75 4.5 0.75C4.79837 0.75 5.08452 0.868526 5.2955 1.0795C5.50647 1.29048 5.625 1.57663 5.625 1.875C5.625 2.17337 5.50647 2.45952 5.2955 2.6705C5.08452 2.88147 4.79837 3 4.5 3ZM6.3375 1.5C6.16406 0.644531 5.40703 0 4.5 0C3.59297 0 2.83594 0.644531 2.6625 1.5H0.375C0.16875 1.5 0 1.66875 0 1.875C0 2.08125 0.16875 2.25 0.375 2.25H2.6625C2.83594 3.10547 3.59297 3.75 4.5 3.75C5.40703 3.75 6.16406 3.10547 6.3375 2.25H11.625C11.8313 2.25 12 2.08125 12 1.875C12 1.66875 11.8313 1.5 11.625 1.5H6.3375Z"
      fill="currentColor"
    />
  </svg>
);

export const TrashIcon = ({ className = 'w-4 h-4' }) => (
  <svg
    className={className}
    width="14"
    height="16"
    viewBox="0 0 14 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="14" height="16" fill="#1E1E1E" />
    <g id="Filtro_tabla_Desktop">
      <rect
        x="-723.5"
        y="-72.5"
        width="1567"
        height="224"
        rx="4.5"
        stroke="#9747FF"
        stroke-dasharray="10 5"
      />
      <g id="Property 1=1 linea">
        <rect
          x="-703.5"
          y="-52.5"
          width="749"
          height="136"
          rx="5.5"
          fill="#02040A"
        />
        <rect
          x="-703.5"
          y="-52.5"
          width="749"
          height="136"
          rx="5.5"
          stroke="#171F2A"
        />
        <g id="Frame 19">
          <g id="Buttons">
            <path
              d="M-15.5 -6C-15.5 -9.03757 -13.0376 -11.5 -10 -11.5H24C27.0376 -11.5 29.5 -9.03757 29.5 -6V22C29.5 25.0376 27.0376 27.5 24 27.5H-10C-13.0376 27.5 -15.5 25.0376 -15.5 22V-6Z"
              stroke="#202A39"
            />
            <g id="Iconos" clipPath="url(#clip0_565_4180)">
              <path
                id="Primary"
                d="M5.55312 1H8.44375C8.61563 1 8.775 1.0875 8.86875 1.23438L9.34688 2H4.65312L5.13125 1.23438C5.22187 1.0875 5.38438 1 5.55625 1H5.55312ZM10.5281 2L9.71875 0.70625C9.44375 0.265625 8.9625 0 8.44687 0H5.55312C5.0375 0 4.55625 0.265625 4.28125 0.70625L3.47187 2H2.00312H1H0.5C0.225 2 0 2.225 0 2.5C0 2.775 0.225 3 0.5 3H1.07187L1.86875 14.1438C1.94062 15.1906 2.8125 16 3.8625 16H10.1375C11.1875 16 12.0563 15.1906 12.1313 14.1438L12.9281 3H13.5C13.775 3 14 2.775 14 2.5C14 2.225 13.775 2 13.5 2H13H11.9969H10.525H10.5281ZM11.9281 3L11.1344 14.0719C11.0969 14.5938 10.6625 15 10.1375 15H3.8625C3.3375 15 2.90312 14.5938 2.86562 14.0719L2.075 3H11.9281Z"
                fill="#CED7ED"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
    <g id="markers line">
      <path
        id="Line 22"
        d="M-25.8868 54L-23 56.8868L-20.1132 54L-23 51.1132L-25.8868 54ZM28 54L28 54.5L28.5 54.5L28.5 54L28 54ZM-23 54.5L-20.45 54.5L-20.45 53.5L-23 53.5L-23 54.5ZM-15.35 54.5L-10.25 54.5L-10.25 53.5L-15.35 53.5L-15.35 54.5ZM-5.15 54.5L-0.0499974 54.5L-0.0499973 53.5L-5.15 53.5L-5.15 54.5ZM5.05 54.5L10.15 54.5L10.15 53.5L5.05 53.5L5.05 54.5ZM15.25 54.5L20.35 54.5L20.35 53.5L15.25 53.5L15.25 54.5ZM25.45 54.5L28 54.5L28 53.5L25.45 53.5L25.45 54.5ZM28.5 54L28.5 51.5658L27.5 51.5658L27.5 54L28.5 54ZM28.5 46.6974L28.5 41.8289L27.5 41.8289L27.5 46.6974L28.5 46.6974ZM28.5 36.9605L28.5 32.0921L27.5 32.0921L27.5 36.9605L28.5 36.9605ZM28.5 27.2237L28.5 22.3553L27.5 22.3553L27.5 27.2237L28.5 27.2237ZM28.5 17.4868L28.5 12.6184L27.5 12.6184L27.5 17.4868L28.5 17.4868ZM28.5 7.75L28.5 2.88158L27.5 2.88158L27.5 7.75L28.5 7.75ZM28.5 -1.98684L28.5 -6.85526L27.5 -6.85526L27.5 -1.98684L28.5 -1.98684ZM28.5 -11.7237L28.5 -16.5921L27.5 -16.5921L27.5 -11.7237L28.5 -11.7237ZM28.5 -21.4605L28.5 -26.3289L27.5 -26.3289L27.5 -21.4605L28.5 -21.4605ZM28.5 -31.1974L28.5 -36.0658L27.5 -36.0658L27.5 -31.1974L28.5 -31.1974ZM28.5 -40.9342L28.5 -45.8027L27.5 -45.8027L27.5 -40.9342L28.5 -40.9342ZM28.5 -50.6711L28.5 -55.5395L27.5 -55.5395L27.5 -50.6711L28.5 -50.6711ZM28.5 -60.4079L28.5 -65.2763L27.5 -65.2763L27.5 -60.4079L28.5 -60.4079ZM28.5 -70.1448L28.5 -75.0132L27.5 -75.0132L27.5 -70.1448L28.5 -70.1448ZM28.5 -79.8816L28.5 -84.75L27.5 -84.75L27.5 -79.8816L28.5 -79.8816ZM28.5 -89.6185L28.5 -94.4869L27.5 -94.4869L27.5 -89.6185L28.5 -89.6185ZM28.5 -99.3553L28.5 -104.224L27.5 -104.224L27.5 -99.3553L28.5 -99.3553ZM28.5 -109.092L28.5 -113.961L27.5 -113.961L27.5 -109.092L28.5 -109.092ZM28.5 -118.829L28.5 -123.697L27.5 -123.697L27.5 -118.829L28.5 -118.829ZM28.5 -128.566L28.5 -131L27.5 -131L27.5 -128.566L28.5 -128.566Z"
        fill="#AF52DE"
      />
    </g>
    <defs>
      <clipPath id="clip0_565_4180">
        <rect width="14" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const EscIcon = ({ className = 'w-4 h-4' }) => (
  <svg
    width="17"
    height="14"
    viewBox="0 0 17 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <rect
      x="1.4"
      y="1.9"
      width="14.2"
      height="10.2"
      rx="2.6"
      stroke="currentColor"
      strokeWidth="0.8"
    />
    <path
      d="M7.15783 8.184L7.15583 8.5H5.38983V5.634H7.15583V5.95H5.77783V6.902H6.89383V7.206H5.77783V8.184H7.15783ZM9.16442 6.082C9.15242 6.102 9.13909 6.11733 9.12442 6.128C9.11109 6.13733 9.09442 6.142 9.07442 6.142C9.05176 6.142 9.02509 6.13067 8.99442 6.108C8.96376 6.08533 8.92509 6.06067 8.87842 6.034C8.83309 6.006 8.77776 5.98067 8.71242 5.958C8.64842 5.93533 8.57042 5.924 8.47842 5.924C8.39176 5.924 8.31509 5.936 8.24842 5.96C8.18309 5.98267 8.12776 6.014 8.08242 6.054C8.03842 6.094 8.00509 6.14133 7.98242 6.196C7.95976 6.24933 7.94842 6.30733 7.94842 6.37C7.94842 6.45 7.96776 6.51667 8.00642 6.57C8.04642 6.622 8.09842 6.66667 8.16242 6.704C8.22776 6.74133 8.30109 6.774 8.38242 6.802C8.46509 6.82867 8.54909 6.85667 8.63442 6.886C8.72109 6.91533 8.80509 6.94867 8.88642 6.986C8.96909 7.022 9.04242 7.068 9.10642 7.124C9.17176 7.18 9.22376 7.24867 9.26242 7.33C9.30242 7.41133 9.32242 7.51133 9.32242 7.63C9.32242 7.75533 9.30109 7.87333 9.25842 7.984C9.21576 8.09333 9.15309 8.18867 9.07042 8.27C8.98909 8.35133 8.88842 8.41533 8.76842 8.462C8.64976 8.50867 8.51442 8.532 8.36242 8.532C8.17576 8.532 8.00642 8.49867 7.85442 8.432C7.70242 8.364 7.57242 8.27267 7.46442 8.158L7.57642 7.974C7.58709 7.95933 7.59976 7.94733 7.61442 7.938C7.63042 7.92733 7.64776 7.922 7.66642 7.922C7.68376 7.922 7.70309 7.92933 7.72442 7.944C7.74709 7.95733 7.77242 7.97467 7.80042 7.996C7.82842 8.01733 7.86042 8.04067 7.89642 8.066C7.93242 8.09133 7.97309 8.11467 8.01842 8.136C8.06509 8.15733 8.11776 8.17533 8.17642 8.19C8.23509 8.20333 8.30109 8.21 8.37442 8.21C8.46642 8.21 8.54842 8.19733 8.62042 8.172C8.69242 8.14667 8.75309 8.11133 8.80242 8.066C8.85309 8.01933 8.89176 7.964 8.91842 7.9C8.94509 7.836 8.95842 7.76467 8.95842 7.686C8.95842 7.59933 8.93842 7.52867 8.89842 7.474C8.85976 7.418 8.80842 7.37133 8.74442 7.334C8.68042 7.29667 8.60709 7.26533 8.52442 7.24C8.44176 7.21333 8.35776 7.18667 8.27242 7.16C8.18709 7.132 8.10309 7.1 8.02042 7.064C7.93776 7.028 7.86442 6.98133 7.80042 6.924C7.73642 6.86667 7.68442 6.79533 7.64442 6.71C7.60576 6.62333 7.58642 6.51667 7.58642 6.39C7.58642 6.28867 7.60576 6.19067 7.64442 6.096C7.68442 6.00133 7.74176 5.91733 7.81642 5.844C7.89242 5.77067 7.98509 5.712 8.09442 5.668C8.20509 5.624 8.33176 5.602 8.47442 5.602C8.63442 5.602 8.77976 5.62733 8.91042 5.678C9.04242 5.72867 9.15842 5.802 9.25842 5.898L9.16442 6.082ZM11.8823 7.908C11.9036 7.908 11.9223 7.91667 11.9383 7.934L12.0923 8.1C11.975 8.236 11.8323 8.342 11.6643 8.418C11.4976 8.494 11.2956 8.532 11.0583 8.532C10.853 8.532 10.6663 8.49667 10.4983 8.426C10.3303 8.354 10.187 8.254 10.0683 8.126C9.94963 7.99667 9.85763 7.842 9.7923 7.662C9.72696 7.482 9.6943 7.284 9.6943 7.068C9.6943 6.852 9.7283 6.654 9.7963 6.474C9.8643 6.294 9.95963 6.13933 10.0823 6.01C10.2063 5.88067 10.3543 5.78067 10.5263 5.71C10.6983 5.638 10.8883 5.602 11.0963 5.602C11.3003 5.602 11.4803 5.63467 11.6363 5.7C11.7923 5.76533 11.9296 5.854 12.0483 5.966L11.9203 6.144C11.9123 6.15733 11.9016 6.16867 11.8883 6.178C11.8763 6.186 11.8596 6.19 11.8383 6.19C11.8143 6.19 11.785 6.17733 11.7503 6.152C11.7156 6.12533 11.6703 6.096 11.6143 6.064C11.5583 6.032 11.4883 6.00333 11.4043 5.978C11.3203 5.95133 11.217 5.938 11.0943 5.938C10.9463 5.938 10.811 5.964 10.6883 6.016C10.5656 6.06667 10.4596 6.14067 10.3703 6.238C10.2823 6.33533 10.2136 6.454 10.1643 6.594C10.115 6.734 10.0903 6.892 10.0903 7.068C10.0903 7.24667 10.1156 7.406 10.1663 7.546C10.2183 7.686 10.2883 7.80467 10.3763 7.902C10.4656 7.998 10.5703 8.07133 10.6903 8.122C10.8116 8.17267 10.9423 8.198 11.0823 8.198C11.1676 8.198 11.2443 8.19333 11.3123 8.184C11.3816 8.17333 11.445 8.15733 11.5023 8.136C11.561 8.11467 11.615 8.088 11.6643 8.056C11.715 8.02267 11.765 7.98333 11.8143 7.938C11.837 7.918 11.8596 7.908 11.8823 7.908Z"
      fill="currentColor"
    />
  </svg>
);

export const EnterIcon = ({ className = 'w-4 h-4' }) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clipPath="url(#clip0_3701_1366)">
      <path
        d="M10 11C10.5523 11 11 10.5523 11 10V2C11 1.44772 10.5523 1 10 1H7C6.44772 1 6 1.44772 6 2V4C6 4.55228 5.55228 5 5 5H2C1.44772 5 1 5.44772 1 6V10C1 10.5523 1.44772 11 2 11H10Z"
        stroke="#CED7ED"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.25 7L4.25 8L5.25 9"
        stroke="#CED7ED"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.5 5.75V7C8.5 7.55228 8.05228 8 7.5 8H4.25"
        stroke="#CED7ED"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_3701_1366">
        <rect width="12" height="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
